import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router";
import { captureError } from "@/shared/errors/errorTracking";
import { Button, EmptyState } from "@/shared/ui";

/** Crash / failed chunk load (e.g. a new deploy replaced the bundles). */
export function RouteError() {
  const error = useRouteError();
  useEffect(() => void captureError(error, { source: "route" }), [error]);
  const detail = isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : undefined;
  return (
    <div className="login">
      <div className="card login-card">
        <EmptyState
          icon="alert"
          title="Đã có lỗi khi hiển thị trang"
          description={detail ?? "Có thể phiên bản mới vừa được triển khai. Tải lại trang để tiếp tục."}
          action={<Button variant="primary" icon="refresh" onClick={() => window.location.reload()}>Tải lại trang</Button>}
        />
      </div>
    </div>
  );
}
